import { IDotDangKyChuyenNganh } from "../../../model/respone/dang-ky-chuyen-nganh/IDotDangKyChuyenNganh";
import { IThietLapDotDangKyChuyenNganh } from "../../../model/respone/dang-ky-chuyen-nganh/IThietLapDotDangKyChuyenNganh";
import {
  IDangKyChuyenNganhSinhVien,
  INguyenVongSinhVienRequest,
} from "../../../model/respone/dang-ky-chuyen-nganh/IDangKyChuyenNganhSinhVien";
import { IKetQuaXetChuyenNganh } from "../../../model/respone/dang-ky-chuyen-nganh/IKetQuaXetChuyenNganh";
import { IDeleteKetQuaDangKyRequest } from "../../../model/request/dang-ky-chuyen-nganh/IDeleteKetQuaDangKyRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDangKyChuyenNganhActionsObj = {
  // Đợt
  LOAD_DOTS_START: undefined,
  LOAD_DOTS_SUCCESS: {} as IDotDangKyChuyenNganh[],
  LOAD_DOTS_ERRR: "",

  SHOW_EDIT_MODAL: {} as IDotDangKyChuyenNganh | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_DOT_START: {} as IDotDangKyChuyenNganh,
  SAVE_DOT_SUCCESS: undefined,
  SAVE_DOT_ERRR: "",

  DELETE_DOT_START: 0,
  DELETE_DOT_SUCCESS: undefined,
  DELETE_DOT_ERRR: "",

  // Chọn đợt + tab
  CHANGE_CURRENT_DOT: 0,
  CHANGE_CURRENT_TAB: "" as "dot-dang-ky" | "thiet-lap" | "sinh-vien" | "ket-qua-xet",

  // Thiết lập
  LOAD_THIET_LAPS_START: 0,
  LOAD_THIET_LAPS_SUCCESS: {} as IThietLapDotDangKyChuyenNganh[],
  LOAD_THIET_LAPS_ERRR: "",
  SUBMIT_THIET_LAPS_START: {} as { dotId: number; data: IThietLapDotDangKyChuyenNganh[] },
  SUBMIT_THIET_LAPS_SUCCESS: undefined,
  SUBMIT_THIET_LAPS_ERRR: "",

  // Sinh viên đăng ký
  LOAD_SINH_VIENS_START: 0,
  LOAD_SINH_VIENS_SUCCESS: {} as IDangKyChuyenNganhSinhVien[],
  LOAD_SINH_VIENS_ERRR: "",
  SUBMIT_NGUYEN_VONG_START: {} as INguyenVongSinhVienRequest,
  SUBMIT_NGUYEN_VONG_SUCCESS: undefined,
  SUBMIT_NGUYEN_VONG_ERRR: "",
  DELETE_KET_QUA_DANG_KY_START: {} as IDeleteKetQuaDangKyRequest,
  DELETE_KET_QUA_DANG_KY_SUCCESS: undefined,
  DELETE_KET_QUA_DANG_KY_ERRR: "",

  // Kết quả xét
  LOAD_KET_QUAS_START: 0,
  LOAD_KET_QUAS_SUCCESS: {} as IKetQuaXetChuyenNganh[],
  LOAD_KET_QUAS_ERRR: "",
  XET_TU_DONG_START: 0,
  XET_TU_DONG_SUCCESS: 0,
  XET_TU_DONG_ERRR: "",
};

export const eDangKyChuyenNganhActionIds = generateActionTypeIds(
  eDangKyChuyenNganhActionsObj,
  "DANG_KY_CHUYEN_NGANH"
);

export type IDangKyChuyenNganhActionTypes = IGenericActionType<
  typeof eDangKyChuyenNganhActionsObj,
  "DANG_KY_CHUYEN_NGANH"
>;
